import { SelectorCardImageStates, } from '../../../../../../components/selectorCardImage/types/cardSelectorImageTheme';
import { commonStyles } from '../commonStyles';
import { SelectorCardImageVariants } from '../variants';
export const getDefaultStyles = (FOUNDATIONS, FONT) => {
    return {
        [SelectorCardImageVariants.DEFAULT]: {
            [SelectorCardImageStates.DEFAULT_UNSELECTED]: {
                ...commonStyles(FOUNDATIONS, {
                    container: {
                        border_color: FOUNDATIONS.color_neutral_border_50,
                        cursor: 'pointer',
                        pointer_events: 'auto',
                    },
                }),
            },
            [SelectorCardImageStates.DEFAULT_SELECTED]: {
                ...commonStyles(FOUNDATIONS, {
                    container: {
                        border_color: FOUNDATIONS.color_accent_selected_border_50,
                        cursor: 'pointer',
                        pointer_events: 'auto',
                    },
                }),
            },
            [SelectorCardImageStates.DISABLED_UNSELECTED]: {
                ...commonStyles(FOUNDATIONS, {
                    container: {
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        cursor: 'default',
                        pointer_events: 'none',
                    },
                    title: {
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                }),
            },
            [SelectorCardImageStates.DISABLED_SELECTED]: {
                ...commonStyles(FOUNDATIONS, {
                    container: {
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        cursor: 'default',
                        pointer_events: 'none',
                    },
                    title: {
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                }),
            },
        },
    };
};
//# sourceMappingURL=default.js.map